import * as React from 'react';
import SideMenu from './SideMenu.jsx';
import './navigationCss/cssOverride.css';
import { DrawerBox } from '../StyledComponents.jsx';
import { useSelector } from 'react-redux';

const PersistentLeftDrawer = () => {
  const featureEnabled = useSelector((state) => state.menu.featureEnabled);

  return (
    <DrawerBox open={featureEnabled}>
      <SideMenu />
    </DrawerBox>
  );
};

export default PersistentLeftDrawer;
